import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const MessageIcon: FC<Props> = (props) => {
  return (
    <svg
      width="28"
      height="29"
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="message icon">
      {/* <title>message icon</title> */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.1968 3.43054C22.7829 3.43054 25.4871 6.35654 25.4871 10.2367V17.633C25.4871 19.6188 24.7849 21.413 23.5088 22.6859C22.364 23.8264 20.8789 24.4305 19.214 24.4305H8.6031C6.94141 24.4305 5.45741 23.8275 4.31156 22.6859C3.03541 21.413 2.33325 19.6188 2.33325 17.633V10.2367C2.33325 6.35654 5.03741 3.43054 8.62356 3.43054H19.1968ZM19.1968 5.04593H8.62356C5.9151 5.04593 3.94864 7.22885 3.94864 10.2367V17.633C3.94864 19.187 4.48279 20.5752 5.45202 21.5412C6.28771 22.3758 7.37864 22.8152 8.60633 22.8152H19.1968C19.1989 22.813 19.2076 22.8152 19.214 22.8152C20.4428 22.8152 21.5326 22.3758 22.3683 21.5412C23.3386 20.5752 23.8717 19.187 23.8717 17.633V10.2367C23.8717 7.22885 21.9053 5.04593 19.1968 5.04593ZM20.894 10.0308C21.1751 10.3765 21.1223 10.8848 20.7766 11.1669L15.9908 15.0568C15.3856 15.5371 14.6619 15.7772 13.9393 15.7772C13.2188 15.7772 12.5005 15.5392 11.8996 15.0632L7.06956 11.1691C6.72171 10.8891 6.66787 10.3797 6.94679 10.0329C7.22787 9.68725 7.73617 9.63233 8.08294 9.91125L12.9086 13.8011C13.5149 14.2814 14.3689 14.2814 14.9796 13.7968L19.7568 9.9134C20.1036 9.63017 20.6119 9.68402 20.894 10.0308Z"
        fill={props.fill || "currentColor" || "#3064C0"}
      />
    </svg>
  );
};

export default MessageIcon;
